<div class="popup-carousel">
  <button class="btn-close" mat-button (click)="closeDialog()">X</button>
  <owl-carousel-o [options]="carouselOptions">
    @for (ads of data().rows; track i; let i = $index;){
    <ng-template carouselSlide>
      <a [href]="ads.link_url" target="_blank" rel="">
        <img class="img-pc" [src]="replaceBucket.replaceBucket(ads.pc_image_url)" [alt]="ads.title" />
        <img class="img-mobile" [src]="replaceBucket.replaceBucket(ads.mobile_image_url)" [alt]="ads.title" />
      </a>
    </ng-template>

    }
  </owl-carousel-o>
</div>
